import React from 'react';
import { Stack, TextField } from '@mui/material';
import { useScrollIntoView } from '../hooks/useScrollIntoView';

interface Props {
  date: string;
  feedback: string;
  onChangeDate: (date: string) => void;
  onChangeFeedback: (text: string) => void;
}

export default function StepDetailsForm({
  date,
  feedback,
  onChangeDate,
  onChangeFeedback,
}: Props) {
  const scrollIntoView = useScrollIntoView();

  const handleTextFieldFocus = (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    scrollIntoView(e.target);
  };

  return (
    <Stack spacing={2}>
      <TextField
        fullWidth
        label="Date"
        type="date"
        InputLabelProps={{ shrink: true }}
        value={date}
        onChange={(e) => onChangeDate(e.target.value)}
        onFocus={handleTextFieldFocus}
      />

      <TextField
        fullWidth
        label="Feedback"
        multiline
        minRows={3}
        value={feedback}
        onChange={(e) => onChangeFeedback(e.target.value)}
        onFocus={handleTextFieldFocus}
      />
    </Stack>
  );
}
